import { Switch, Match, useContext } from 'solid-js';
import { EnvelopeIcon } from '../../../../icons-library/envelope';
import { PhoneIcon } from '../../../../icons-library/phone';
import { StyledShortcutMenuIcon } from './shortcuts-menu-icons.styles';
import { AppContext } from '../../../../../app-context-provider/app-context-provider';

export const ShortcutMenuIcons = (props: ShortcutMenuIconsProps) => {
    const { localize } = useContext(AppContext);

    return (
        <StyledShortcutMenuIcon>
            <Switch fallback={<p>${`icon with name ${props.name} not implemented`}</p>}>
                <Match when={props.name === 'envelope'}>
                    <EnvelopeIcon fill="white" width={3.57} height={1.71} ariaLabel={localize('email', 'Email')} />
                </Match>
                <Match when={props.name === 'phone'}>
                    <PhoneIcon fill="white" width={3.57} ariaLabel={localize('phone', 'Phone')} />
                </Match>
            </Switch>
        </StyledShortcutMenuIcon>
    );
};
type ShortcutMenuIconsProps = {
    name?: 'envelope' | 'phone';
};
